module.exports = __webpack_public_path__ + "static/img/16_1.f93c1fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/officeImg/index/16_1.png
// module id = ULvZ
// module chunks = 1